/*
  perf-video.js — Videolar sayfa yüklenirken indirilmez.
  <video data-perf-video data-src="..." [data-src-hd="..."] [data-autoplay]>
  - Görünür alana (200px pay ile) girince kaynak bağlanır; data-autoplay varsa sessiz oynatılır.
  - Alandan çıkınca durdurulur.
  - Instagram/Facebook uygulama içi tarayıcı: ilk dokunuş/kaydırmada tekrar oynatma denenir.
  - Herhangi bir kodun video.play() çağrısı da kaynağı otomatik bağlar.
*/
(function () {
  'use strict';
  var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
  var seen = (typeof WeakSet === 'function') ? new WeakSet() : null;
  var seenList = [];

  function isSeen(v) { return seen ? seen.has(v) : seenList.indexOf(v) !== -1; }
  function markSeen(v) { if (seen) { seen.add(v); } else { seenList.push(v); } }

  function srcFor(v) {
    return (isDesktop && v.getAttribute('data-src-hd')) ? v.getAttribute('data-src-hd') : v.getAttribute('data-src');
  }

  function ensureSrc(v) {
    if (!v || v.getAttribute('src')) return;
    var s = srcFor(v);
    if (!s) return;
    v.setAttribute('src', s);
    try { v.load(); } catch (e) {}
  }

  function safePlay(v) {
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') { p.catch(function () {}); }
  }

  function tryAutoplay(v) {
    if (!v.hasAttribute('data-autoplay')) return;
    if (!v.getAttribute('data-perf-inview')) return;
    ensureSrc(v);
    if (v.paused) safePlay(v);
  }

  // Başka kodlar (slick, tema JS) doğrudan play() çağırırsa kaynağı bağla
  if (window.HTMLMediaElement && HTMLMediaElement.prototype.play) {
    var origPlay = HTMLMediaElement.prototype.play;
    HTMLMediaElement.prototype.play = function () {
      if (this.hasAttribute && this.hasAttribute('data-perf-video')) ensureSrc(this);
      return origPlay.apply(this, arguments);
    };
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.setAttribute('data-perf-inview', '1');
          if (v.getAttribute('data-poster') && !v.getAttribute('poster')) { v.setAttribute('poster', v.getAttribute('data-poster')); }
          tryAutoplay(v);
        } else {
          v.removeAttribute('data-perf-inview');
          if (!v.paused) { try { v.pause(); } catch (e) {} }
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
  }

  function observe(v) {
    if (isSeen(v)) return;
    markSeen(v);
    if (io) {
      io.observe(v);
    } else {
      v.setAttribute('data-perf-inview', '1');
      if (v.getAttribute('data-poster') && !v.getAttribute('poster')) { v.setAttribute('poster', v.getAttribute('data-poster')); }
      tryAutoplay(v);
    }
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('video[data-perf-video]');
    for (var i = 0; i < list.length; i++) observe(list[i]);
  }

  function retryVisible() {
    var list = document.querySelectorAll('video[data-perf-video][data-autoplay][data-perf-inview]');
    for (var i = 0; i < list.length; i++) { if (list[i].paused) { ensureSrc(list[i]); safePlay(list[i]); } }
  }

  function init() {
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('video[data-perf-video]')) observe(n);
            else if (n.querySelectorAll) scan(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Uygulama içi tarayıcılar autoplay'i bloklarsa ilk etkileşimde tekrar dene
    ['touchstart', 'touchend', 'click', 'scroll', 'pointerdown'].forEach(function (e) {
      document.addEventListener(e, retryVisible, { capture: true, passive: true });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) retryVisible(); });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }

  // ---- Ertelenmiş görseller (.perf-defer): data-srcset -> srcset
  function hydrateImg(img) {
    if (!img || !img.getAttribute || !img.getAttribute('data-srcset')) return;
    img.setAttribute('sizes', img.getAttribute('data-sizes') || '100vw');
    img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-srcset'); img.removeAttribute('data-src'); img.removeAttribute('data-sizes');
    img.classList.remove('perf-defer');
  }
  function hydrateAll(root) {
    var list = (root || document).querySelectorAll('img.perf-defer');
    for (var i = 0; i < list.length; i++) hydrateImg(list[i]);
  }
  ['touchstart', 'pointerdown', 'keydown', 'wheel', 'scroll'].forEach(function (e) {
    window.addEventListener(e, function onFirst() { hydrateAll(document); window.removeEventListener(e, onFirst); }, { passive: true });
  });
  window.perfImage = { hydrate: hydrateImg, hydrateAll: hydrateAll };

  window.perfVideo = {
    load: ensureSrc,
    play: function (v) { if (!v) return; ensureSrc(v); safePlay(v); },
    scan: scan
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
